import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center justify-center text-center">
      <span className="font-heading font-black text-[6rem] md:text-[9rem] leading-none text-primary-100 select-none">
        404
      </span>
      <h1 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 mt-2 mb-2">
        页面走丢了
      </h1>
      <p className="text-sm text-foreground-600 mb-8 max-w-md">
        你访问的页面不存在或已被移除，不如去看看我们的精选课程吧。
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="h-11 px-6 inline-flex items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          回到首页
        </Link>
        <Link
          to="/category"
          className="h-11 px-6 inline-flex items-center rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          浏览课程分类
        </Link>
      </div>
    </div>
  );
}